// extracted by mini-css-extract-plugin
export var cardLayout = "_7d-1";
export var paginationContainer = "_7d-0";